import React from 'react';
import { INavbarIconProps } from '../type';

const MySubscriptionIcon: React.FC<INavbarIconProps> = ({ color }) => {
   return (
      <svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path
            d='M8 1.332a6.667 6.667 0 1 1 0 13.333A6.667 6.667 0 0 1 8 1.332m.107 9.333c-1.357 0-2.578.58-3.431 1.504A5.3 5.3 0 0 0 8 13.332a5.3 5.3 0 0 0 3.444-1.261 4.65 4.65 0 0 0-3.338-1.406m-.106-8a5.333 5.333 0 0 0-4.257 8.548 5.98 5.98 0 0 1 4.363-1.881c1.656 0 3.156.671 4.242 1.756A5.333 5.333 0 0 0 8 2.665m0 .667a2.667 2.667 0 1 1 0 5.333 2.667 2.667 0 0 1 0-5.333m0 1.333a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667'
            fill={color}
         />
      </svg>
   );
};

export default MySubscriptionIcon;
